import { createSelector } from "@ngrx/store";
import { AppState } from "@store/app.state";
const selectFeature = (state: AppState) => state.docViewer;

export const currentActionPanelView = () =>
	createSelector(
		selectFeature,
		(state) => {
			return state?.currentActionPanelView;
		}
	);
